import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from "vue";
import store from "@/vue/planning/store/store";
import RadioCircle from "@/vue/common/radioCircle.vue";

// computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay";

// config
import colors from "@/config/colors";


export default /*#__PURE__*/_defineComponent({
  __name: 'transportSwitch',
  setup(__props) {

const options = [
	{
		label: store.state.content.planner_formulaWithTransport,
		value: true,
	},
	{
		label: store.state.content.planner_noTransport,
		value: false,
	},
];

// computed

// methods
const handleSwitch = (bool: boolean) => {
	store.commit("setTransport", bool);
	nextTick(() => {
		store.dispatch("setPackage", packagesToDisplay.value[0].codePackage);
	});
};

return { __sfc: true,options, handleSwitch, store, RadioCircle, colors }
}

})